<div [formGroup]="form">
<div class="section-container">
    <div class="section-title">
        <mat-icon class="material-symbols-outlined">rule</mat-icon>
        <span>{{ modoExcecao ? 'Regra de Exceção' : 'Regra Padrão' }}</span>
        <div class="section-title-actions ms-auto">
            <span class="personalizar-tooltip-wrap"
                [matTooltip]="personalizarTooltip"
                [matTooltipDisabled]="!personalizarBloqueado">
                <button mat-button type="button" class="btn-section"
                    [matBadge]="personalizadasCount" [matBadgeHidden]="personalizadasCount === 0"
                    [disabled]="personalizarBloqueado"
                    (click)="onPersonalizar()">
                    <mat-icon class="material-symbols-outlined">settings</mat-icon>
                    Personalizar fórmulas
                </button>
            </span>
        </div>
    </div>

    <div class="row g-3">

        <!-- CSOSN -->
        <div class="col-12 col-md-8">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>{{ modoExcecao ? 'CSOSN da exceção' : 'CSOSN' }}</mat-label>
                <mat-select formControlName="csosn">
                    <mat-option [value]="null">— Selecione —</mat-option>
                    @for (c of csosnsDaOperacao; track c.codigo) {
                    <mat-option [value]="c.codigo">{{ c.codigo }} – {{ c.descricao }}</mat-option>
                    }
                </mat-select>
                @if (form.get('csosn')?.hasError('required') && form.get('csosn')?.touched) {
                <mat-error>CSOSN é obrigatório.</mat-error>
                }
            </mat-form-field>
        </div>

        <!-- CFOP -->
        <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>CFOP</mat-label>
                <input matInput type="text" inputmode="numeric"
                    [formControl]="cfopControl"
                    [mask]="masks.cfop" [patterns]="cfopPatterns"
                    [placeholder]="cfopPlaceholder"
                    (keydown)="onCfopKeydown($event)">
                <button mat-icon-button matSuffix type="button"
                    matTooltip="Pesquisar CFOP"
                    (click)="pesquisarCfop()">
                    <mat-icon>search</mat-icon>
                </button>
                <mat-icon                    
                    matSuffix
                    [matTooltip]="cfopTooltipInfo"
                    matTooltipClass="cfop-tooltip"
                    matTooltipPosition="above">
                    info_outline
                </mat-icon>
                @if (cfopControl?.hasError('cfopTipoInvalido') && cfopControl?.touched) {
                <mat-error>CFOP inválido para o tipo de operação selecionado.</mat-error>
                }
            </mat-form-field>
        </div>

        <!-- Alert CSOSN meta -->
        @if (csosnTexto) {
        <div class="col-12">
            <app-alert-card [type]="csosnTexto.alertaTipo" [title]="csosnTexto.alertaTitulo">
                {{ csosnTexto.alertaTexto }}
            </app-alert-card>
        </div>
        }

        <!-- Benefícios fiscais: sempre visível, livre e opcional para qualquer CSOSN -->
        <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Código do Benefício Fiscal (cBenef)</mat-label>
                <input matInput type="text" formControlName="codigoBeneficioFiscal" placeholder="Ex: SP012345"
                    matTooltip="Verifique a compatibilidade com a UF, o CSOSN e a legislação vigente.">
            </mat-form-field>
        </div>

        <!-- Crédito SN -->
        @if (ativo('pCredSN')) {
        <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Alíquota efetiva ICMS (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pCredIcmsSn">
                @if (form.get('pCredIcmsSn')?.hasError('required') && form.get('pCredIcmsSn')?.touched) {
                <mat-error>Alíquota efetiva ICMS é obrigatória.</mat-error>
                }
            </mat-form-field>
        </div>
        }

        <!-- DIFAL: independente do CSOSN — nasce da operação, não do código de tributação -->
        <div class="col-12 col-md-4 d-flex align-items-center">
            <mat-slide-toggle class="app-toggle-compact" formControlName="isDifalHabilitado">
                {{ difalLabel }}
            </mat-slide-toggle>
        </div>

        <!-- ICMS próprio (CSOSN 900) -->
        @if (algumAtivo(['modBC', 'pRedBC', 'pICMS'])) {
        <div class="col-12">
            <div class="sub-section-container">
                <div class="sub-section-title">
                    <mat-icon>calculate</mat-icon>
                    <span>ICMS Próprio</span>
                </div>
                <div class="row g-3 mt-1">
                    @if (ativo('modBC')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Modalidade da BC do ICMS</mat-label>
                            <mat-select formControlName="modalidadeBc">
                                <mat-option [value]="null">— Selecione —</mat-option>
                                @for (m of modalidadesBc; track m.valor) {
                                <mat-option [value]="m.valor">{{ m.descricao }}</mat-option>
                                }
                            </mat-select>
                            @if (form.get('modalidadeBc')?.hasError('required') && form.get('modalidadeBc')?.touched) {
                            <mat-error>Preenchimento obrigatório.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                    @if (ativo('pRedBC')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Redução da Base de Cálculo (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pRedBc">
                            @if (form.get('pRedBc')?.hasError('required') && form.get('pRedBc')?.touched) {
                            <mat-error>Preenchimento obrigatório.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                    @if (ativo('pICMS')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Alíquota ICMS (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pIcms">
                            @if (form.get('pIcms')?.hasError('required') && form.get('pIcms')?.touched) {
                            <mat-error>Preenchimento obrigatório.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                </div>
            </div>
        </div>
        }

        <!-- Parâmetros ST -->
        @if (algumAtivo(['modBCST', 'pMVAST', 'pRedBCST', 'pICMSST', 'pFCPST'])) {
        <div class="col-12">
            <div class="sub-section-container">
                <div class="sub-section-title">
                    <mat-icon>swap_horiz</mat-icon>
                    <span>Substituição Tributária (ICMS-ST)</span>
                </div>
                <div class="row g-3 mt-1">
                    @if (ativo('modBCST')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Modalidade de BC da ST</mat-label>
                            <mat-select formControlName="modalidadeBcSt">
                                <mat-option [value]="null">— Selecione —</mat-option>
                                @for (m of modalidadesBcSt; track m.valor) {
                                <mat-option [value]="m.valor">{{ m.descricao }}</mat-option>
                                }
                            </mat-select>
                            @if (form.get('modalidadeBcSt')?.hasError('required') && form.get('modalidadeBcSt')?.touched) {
                            <mat-error>Modalidade da BC do ST é obrigatória.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                    @if (ativo('pMVAST')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>MVA ajustado Simples (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pMvaStIcmsSn">
                            @if (form.get('pMvaStIcmsSn')?.hasError('required') && form.get('pMvaStIcmsSn')?.touched) {
                            <mat-error>Preenchimento obrigatório.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                    @if (ativo('pRedBCST')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Redução da Base de Cálculo ST (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pRedBcSt">
                            @if (form.get('pRedBcSt')?.hasError('required') && form.get('pRedBcSt')?.touched) {
                            <mat-error>Preenchimento obrigatório.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                    @if (ativo('pICMSST')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Alíquota ICMS-ST (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pIcmsSt">
                            @if (form.get('pIcmsSt')?.hasError('required') && form.get('pIcmsSt')?.touched) {
                            <mat-error>Alíquota do ICMS ST é obrigatória.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                    @if (ativo('pFCPST')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>FCP retido por ST (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pFcpSt">
                            @if (form.get('pFcpSt')?.hasError('required') && form.get('pFcpSt')?.touched) {
                            <mat-error>Preenchimento obrigatório.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                </div>
            </div>
        </div>
        }

        <!-- ST Retido / CSOSN 500 -->
        @if (algumAtivo(['pST', 'pFCPSTRet', 'obterStCompra'])) {
        <div class="col-12">
            <div class="sub-section-container">
                <div class="sub-section-title">
                    <mat-icon>receipt</mat-icon>
                    <span>ST Cobrada Anteriormente</span>
                </div>
                <div class="row g-3 mt-1">
                    @if (ativo('pST')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Alíquota suportada pelo consumidor (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pSt">
                            @if (form.get('pSt')?.hasError('required') && form.get('pSt')?.touched) {
                            <mat-error>Preenchimento obrigatório.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                    @if (ativo('pFCPSTRet')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>FCP ST Retido (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pFcpStRet">
                            @if (form.get('pFcpStRet')?.hasError('required') && form.get('pFcpStRet')?.touched) {
                            <mat-error>Preenchimento obrigatório.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                    @if (ativo('obterStCompra')) {
                    <div class="col-12 col-md-4 d-flex align-items-center">
                        <mat-slide-toggle class="app-toggle-compact" formControlName="obterIcmsStCompra">
                            Obter ICMS-ST da nota de compra
                        </mat-slide-toggle>
                    </div>
                    }
                </div>
            </div>
        </div>
        }

        <!-- ICMS Efetivo B2C -->
        @if (algumAtivo(['pRedBCEfet', 'pICMSEfet'])) {
        <div class="col-12">
            <div class="sub-section-container">
                <div class="sub-section-title">
                    <mat-icon>storefront</mat-icon>
                    <span>ICMS Efetivo (B2C)</span>
                </div>
                <div class="row g-3 mt-1">
                    @if (ativo('pRedBCEfet')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Redução da Base de Cálculo Efetiva (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pRedBcEfet">
                            @if (form.get('pRedBcEfet')?.hasError('required') && form.get('pRedBcEfet')?.touched) {
                            <mat-error>Percentual de redução BC efetiva é obrigatório.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                    @if (ativo('pICMSEfet')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Alíquota efetiva ICMS (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pIcmsEfet">
                            @if (form.get('pIcmsEfet')?.hasError('required') && form.get('pIcmsEfet')?.touched) {
                            <mat-error>Alíquota do ICMS efetivo é obrigatória.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                </div>
            </div>
        </div>
        }

    </div>
</div>
</div>
